// @flow
import * as crypto from 'crypto'

export const isEmailValid = (email?: string | null): boolean => {
  // eslint-disable-next-line no-useless-escape
  if (!email) {
    return false
  }
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return email !== '' && re.test(String(email).toLowerCase())
}

export const createReferId = (userId: string): string => {
  const sha1Hash = crypto.createHash('sha1').update(userId).digest('hex')
  // only grab the last 6 digits
  const referId = sha1Hash.slice(0, 6)
  return referId
}
